import {
    Box,
    Button,
    createListCollection,
    Field,
    Flex,
    Grid,
    GridItem,
    Icon,
    Input,
    InputGroup,
    Link,
    Select,
    Text,
    useBreakpointValue,
} from "@chakra-ui/react";
import { InfoIcon } from "@phosphor-icons/react";
import React, { useState } from "react";

import { Checkbox } from "@/components/ui/checkbox";
import { toaster } from "@/components/ui/toaster";
import { Tooltip } from "@/components/ui/tooltip";
import { usePostFormMutation } from "@/hooks/microservicesApi";

const FormRegistro = ({ corretajeFieldOptions, guiarentFieldOptions, otherFieldOptions }) => {
    const [desarrolloInteres, setDesarrolloInteres] = useState("");
    const [nombreAsesor, setNombreAsesor] = useState("");
    const [telefonoPaisAsesor, setTelefonoPaisAsesor] = useState("52");
    const [telefonoAsesor, setTelefonoAsesor] = useState("");
    const [emailAsesor, setEmailAsesor] = useState("");
    const [nombre, setNombre] = useState("");
    const [lastname, setLastname] = useState("");
    const [telefonoPais, setTelefonoPais] = useState("52");
    const [telefono, setTelefono] = useState("");
    const [email, setEmail] = useState("");
    const [nombreAsesorAt, setNombreAsesorAt] = useState("");
    const [isAt, setIsAt] = useState("");
    const [medio, setMedio] = useState("");
    const [postForm] = usePostFormMutation();
    const [project, setProject] = useState("");
    const [propertyCode, setPropertyCode] = useState("");
    const [invalidCode, setInvalidCode] = useState(false);
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);

    const isGreaterThanMd = useBreakpointValue({ base: false, md: true });

    const contactOrigin = createListCollection({
        items: [
            { value: "Prospección", label: "Prospección" },
            { value: "Wiggot", label: "Wiggot" },
            { value: "Página web", label: "Página web" },
            { value: "Punto de venta", label: "Punto de venta" },
            { value: "Evento", label: "Evento" },
        ],
    });

    const confirmOptions = createListCollection({
        items: [
            { value: "Sí", label: "Sí" },
            { value: "No", label: "No" },
        ],
    });

    const developInterest = createListCollection({
        items: [
            { label: "Propiedad de corretaje", value: "Propiedad de corretaje" },
            { label: "Desarrollos en preventa", value: "Desarrollos en preventa" },
        ],
    });

    const combinedFieldOptions = createListCollection({
        items: (() => {
            const allItems = [
                ...(corretajeFieldOptions?.items || []),
                ...(guiarentFieldOptions?.items || []),
            ];
            // Remove duplicates based on value
            const seen = new Set();
            return allItems.filter((item) => {
                if (seen.has(item.value)) {
                    return false;
                }
                seen.add(item.value);
                return true;
            });
        })(),
    });

    const propertyCodeChange = (e) => {
        const value = e.target.value;
        const isAlphanumeric = /^[a-zA-Z0-9]*$/.test(value);

        if (!isAlphanumeric) {
            setInvalidCode(true);
        } else {
            setInvalidCode(false);
            setPropertyCode(value);
        }
    };

    const handleSubmit = () => {
        const body = {
            id: "1149f55e-bdd0-43d9-844c-59f6e3273da1",
            body: {
                fields: [
                    {
                        name: "nombre_del_asesor_de_la_inmobiliaria",
                        value: nombreAsesor,
                    },
                    {
                        name: "numero_del_asesor_de_la_inmobiliaria",
                        value: telefonoPaisAsesor + "" + telefonoAsesor,
                    },
                    {
                        name: "correo_del_asesor_de_la_inmobiliaria",
                        value: emailAsesor,
                    },
                    {
                        name: "firstname",
                        value: nombre,
                    },
                    {
                        name: "lastname",
                        value: lastname,
                    },
                    {
                        name: "nmero_de_telfono",
                        value: telefonoPais + "" + telefono,
                    },
                    {
                        name: "email",
                        value: email,
                    },
                    {
                        name: "desarrollo_de_interes_soy_inmobiliaria_",
                        value: project,
                    },
                    {
                        name: "wiggot",
                        value: propertyCode,
                    },
                    {
                        name: "ya_estas_siendo_atendido_por_un_asesor_",
                        value: isAt === "No" ? false : true,
                    },
                    {
                        name: "message",
                        value: nombreAsesorAt,
                    },
                    {
                        name: "acepto_terminos_del_aviso_de_privacidad",
                        value: true,
                    },
                    {
                        name: "medio",
                        value: medio,
                    },
                ],
                context: {
                    ipAddress: "3.14.97.137",
                    pageUri: "www.grupoguia.mx",
                    pageName: "Grupo Guia | Registro cliente inmobiliaria",
                },
            },
        };

        postForm(body)
            .then((response) => {
                toaster.create({
                    title: "¡Exito!",
                    description: "Los datos se enviaron exitosamente",
                    type: "success",
                    duration: 4000,
                    closable: true,
                });
                setTimeout(function () {
                    window.location.reload();
                }, 7000);
            })
            .catch(() => {
                toaster.create({
                    title: "Ooops!",
                    description:
                        "Al parecer hubo un error al procesar el envio de los datos... intenta nuevamente.",
                    type: "error",
                    duration: 4000,
                    closable: true,
                });
            });
    };

    return (
        <>
            <Text fontSize="3xl" fontWeight={700} textAlign="center" color="black">
                Registro de cliente
            </Text>
            <form
                style={{
                    width: "80%",
                    margin: "auto",
                    marginTop: "2rem",
                    marginBottom: "2rem",
                    textAlign: "-webkit-center",
                }}
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                }}
            >
                <Grid
                    templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }}
                    gap={4}
                    alignItems="center"
                    mt={2}
                    pt={6}
                    maxW="4xl"
                    margin="auto"
                    my={12}
                    color="black"
                >
                    <GridItem colSpan={{ base: 1, md: 2 }}>
                        <Text fontWeight={700} fontSize="lg" textAlign="left" mb="4">
                            Datos del asesor de inmobiliaria
                        </Text>
                        <Field.Root mb={3}>
                            <Input
                                borderWidth={1.5}
                                borderColor="#D9D9D9"
                                rounded="full"
                                boxShadow="none"
                                _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                placeholder="Nombre del asesor"
                                marginBottom="10px"
                                id="nombre_asesor"
                                type="text"
                                py={5}
                                px={4}
                                value={nombreAsesor}
                                required
                                onChange={(e) => {
                                    e.preventDefault();
                                    setNombreAsesor(e.target.value);
                                }}
                                onBlur={(e) => {
                                    e.preventDefault();
                                    setNombreAsesor(e.target.value);
                                }}
                            />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={1}>
                        <Field.Root mb={3}>
                            <InputGroup
                                marginBottom="20px"
                                borderLeftRadius="full"
                                overflow="hidden"
                                backgroundColor="#FFFFFF"
                                rounded="full"
                                startAddon={
                                    <Flex
                                        backgroundColor="#FFFFFF"
                                        rounded="full"
                                        borderColor="#D9D9D9"
                                    >
                                        <Flex px={3} color="black" alignItems="center">
                                            +
                                        </Flex>
                                        <Input
                                            borderWidth={0}
                                            padding="0px"
                                            borderRadius="0px"
                                            w="45px"
                                            type="number"
                                            id="telefono_pais_asesor"
                                            paddingRight="10px"
                                            py={2}
                                            value={telefonoPaisAsesor}
                                            required
                                            onChange={(e) => {
                                                e.preventDefault();
                                                setTelefonoPaisAsesor(e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                e.preventDefault();
                                                setTelefonoPaisAsesor(e.target.value);
                                            }}
                                        />
                                    </Flex>
                                }
                                startAddonProps={{
                                    borderRightColor: "#D9D9D9",
                                    borderTopColor: "#D9D9D9",
                                    borderBottomColor: "#D9D9D9",
                                    backgroundColor: "#FFFFFF",
                                    fontFamily: "Montserrat",
                                    color: "black",
                                    rounded: "full",
                                }}
                            >
                                <Input
                                    borderRadius="24px"
                                    placeholder="Teléfono"
                                    borderColor="#D9D9D9"
                                    type="number"
                                    id="telefono_asesor"
                                    py={5}
                                    px={2}
                                    value={telefonoAsesor}
                                    required
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setTelefonoAsesor(e.target.value);
                                    }}
                                    onBlur={(e) => {
                                        e.preventDefault();
                                        setTelefonoAsesor(e.target.value);
                                    }}
                                />
                            </InputGroup>
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={1}>
                        <Field.Root mb={3}>
                            <Input
                                borderWidth={1.5}
                                borderColor="#D9D9D9"
                                rounded="full"
                                boxShadow="none"
                                _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                placeholder="Correo electónico"
                                marginBottom="10px"
                                id="email_asesor"
                                type="text"
                                py={5}
                                px={4}
                                value={emailAsesor}
                                required
                                onChange={(e) => {
                                    e.preventDefault();
                                    setEmailAsesor(e.target.value);
                                }}
                                onBlur={(e) => {
                                    e.preventDefault();
                                    setEmailAsesor(e.target.value);
                                }}
                            />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={{ base: 1, md: 2 }}>
                        <Text fontWeight={700} fontSize="lg" textAlign="left">
                            Datos del cliente
                        </Text>
                    </GridItem>
                    <GridItem colSpan={{ base: 1, md: 2 }}>
                        <Field.Root mb={3}>
                            <Input
                                borderWidth={1.5}
                                borderColor="#D9D9D9"
                                rounded="full"
                                boxShadow="none"
                                _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                placeholder="Nombre(s)"
                                marginBottom="10px"
                                id="nombre_cliente"
                                type="text"
                                py={5}
                                px={4}
                                value={nombre}
                                required
                                onChange={(e) => {
                                    e.preventDefault();
                                    setNombre(e.target.value);
                                }}
                                onBlur={(e) => {
                                    e.preventDefault();
                                    setNombre(e.target.value);
                                }}
                            />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={{ base: 1, md: 2 }}>
                        <Field.Root mb={3}>
                            <Input
                                borderWidth={1.5}
                                borderColor="#D9D9D9"
                                rounded="full"
                                boxShadow="none"
                                _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                placeholder="Apellidos"
                                marginBottom="10px"
                                id="apellidos"
                                type="text"
                                py={5}
                                px={4}
                                value={lastname}
                                required
                                onChange={(e) => {
                                    e.preventDefault();
                                    setLastname(e.target.value);
                                }}
                                onBlur={(e) => {
                                    e.preventDefault();
                                    setLastname(e.target.value);
                                }}
                            />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={1}>
                        <Field.Root mb={3}>
                            <InputGroup
                                marginBottom="20px"
                                backgroundColor="#FFFFFF"
                                rounded="full"
                                startAddon={
                                    <Flex
                                        backgroundColor="#FFFFFF"
                                        rounded="full"
                                        borderColor="#D9D9D9"
                                    >
                                        <Flex px={3} color="black" alignItems="center">
                                            +
                                        </Flex>
                                        <Input
                                            borderWidth={0}
                                            padding="0px"
                                            borderRadius="0px"
                                            w="45px"
                                            type="number"
                                            id="telefono_pais_asesor"
                                            paddingRight="10px"
                                            py={2}
                                            value={telefonoPais}
                                            required
                                            onChange={(e) => {
                                                e.preventDefault();
                                                setTelefonoPais(e.target.value);
                                            }}
                                            onBlur={(e) => {
                                                e.preventDefault();
                                                setTelefonoPais(e.target.value);
                                            }}
                                        />
                                    </Flex>
                                }
                                startAddonProps={{
                                    borderRightColor: "#D9D9D9",
                                    borderTopColor: "#D9D9D9",
                                    borderBottomColor: "#D9D9D9",
                                    backgroundColor: "#FFFFFF",
                                    fontFamily: "Montserrat",
                                    color: "black",
                                    rounded: "full",
                                }}
                            >
                                <Input
                                    borderRadius="24px"
                                    placeholder="Teléfono"
                                    borderColor="#D9D9D9"
                                    type="number"
                                    id="telefono"
                                    py={5}
                                    px={2}
                                    value={telefono}
                                    required
                                    onChange={(e) => {
                                        e.preventDefault();
                                        setTelefono(e.target.value);
                                    }}
                                    onBlur={(e) => {
                                        e.preventDefault();
                                        setTelefono(e.target.value);
                                    }}
                                />
                            </InputGroup>
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={1}>
                        <Field.Root mb={3}>
                            <Input
                                borderWidth={1.5}
                                borderColor="#D9D9D9"
                                rounded="full"
                                boxShadow="none"
                                _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                placeholder="Correo electónico"
                                marginBottom="10px"
                                id="email_cliente"
                                type="text"
                                py={5}
                                px={4}
                                value={email}
                                required
                                onChange={(e) => {
                                    e.preventDefault();
                                    setEmail(e.target.value);
                                }}
                                onBlur={(e) => {
                                    e.preventDefault();
                                    setEmail(e.target.value);
                                }}
                            />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={{ base: 1, md: 2 }}>
                        <Field.Root mb={0}>
                            <Select.Root
                                collection={developInterest}
                                borderWidth={1.5}
                                borderColor="#D9D9D9"
                                rounded="full"
                                boxShadow="none"
                                _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                marginBottom="10px"
                                id="desarrollo_interes"
                                type="text"
                                value={desarrolloInteres == "" ? [] : [desarrolloInteres]}
                                required
                                onValueChange={(details) => {
                                    setDesarrolloInteres(details.value[0]);
                                    setProject("");
                                }}
                            >
                                <Select.HiddenSelect />
                                <Select.Control>
                                    <Select.Trigger pl={4} rounded="full">
                                        <Select.ValueText
                                            color="gray.500"
                                            placeholder="¿Cuál es el producto de interés de tu cliente?"
                                        />
                                    </Select.Trigger>
                                    <Select.IndicatorGroup pr={4}>
                                        <Select.Indicator />
                                    </Select.IndicatorGroup>
                                </Select.Control>
                                <Select.Positioner>
                                    <Select.Content p={2}>
                                        {developInterest.items.map((dev) => (
                                            <Select.Item
                                                item={dev}
                                                key={dev.value}
                                                color="gray.600"
                                                p={1}
                                            >
                                                <Select.ItemText>{dev.label}</Select.ItemText>
                                                <Select.ItemIndicator />
                                            </Select.Item>
                                        ))}
                                    </Select.Content>
                                </Select.Positioner>
                            </Select.Root>
                        </Field.Root>
                    </GridItem>
                    {desarrolloInteres === "Propiedad de corretaje" && (
                        <GridItem colSpan={{ base: 1, md: 2 }}>
                            <Grid
                                templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(2, 1fr)" }}
                                gap={4}
                                alignItems="center"
                                color="black"
                            >
                                <GridItem colSpan={1}>
                                    <Field.Root mb={0}>
                                        <Select.Root
                                            collection={combinedFieldOptions}
                                            borderWidth={1.5}
                                            borderColor="#D9D9D9"
                                            rounded="full"
                                            boxShadow="none"
                                            _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                            marginBottom="10px"
                                            id="corretaje_project"
                                            type="text"
                                            value={project == "" ? [] : [project]}
                                            required
                                            onValueChange={(details) => {
                                                setProject(details.value[0]);
                                            }}
                                        >
                                            <Select.HiddenSelect />
                                            <Select.Control>
                                                <Select.Trigger pl={4} rounded="full">
                                                    <Select.ValueText
                                                        color="gray.500"
                                                        placeholder="Selecciona un producto"
                                                    />
                                                </Select.Trigger>
                                                <Select.IndicatorGroup pr={4}>
                                                    <Select.Indicator />
                                                </Select.IndicatorGroup>
                                            </Select.Control>
                                            <Select.Positioner>
                                                <Select.Content p={2}>
                                                    {combinedFieldOptions.items.map((field) => (
                                                        <Select.Item
                                                            item={field}
                                                            key={field.value}
                                                            color="gray.600"
                                                            p={1}
                                                        >
                                                            <Select.ItemText>
                                                                {field.label}
                                                            </Select.ItemText>
                                                            <Select.ItemIndicator />
                                                        </Select.Item>
                                                    ))}
                                                </Select.Content>
                                            </Select.Positioner>
                                        </Select.Root>
                                    </Field.Root>
                                </GridItem>
                                <GridItem colSpan={1}>
                                    <Field.Root invalid={invalidCode}>
                                        <Box
                                            display="flex"
                                            alignItems="center"
                                            borderWidth={1.5}
                                            borderColor="#D9D9D9"
                                            rounded="full"
                                            boxShadow="none"
                                            _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                            overflow="hidden"
                                            mb={3}
                                            w="100%"
                                        >
                                            <Input
                                                borderWidth="0"
                                                placeholder="Código de propiedad"
                                                id="property_code"
                                                type="text"
                                                py={5}
                                                px={4}
                                                value={propertyCode}
                                                required
                                                onChange={propertyCodeChange}
                                                onBlur={() => setInvalidCode(false)}
                                            />
                                            <Tooltip
                                                content="El código de propiedad se encuentra en la parte superior de la ficha de la propiedad o desarrollo en la web de Grupo Guía | Excelencia Inmobiliaria"
                                                open={isTooltipOpen}
                                                onOpenChange={(e) => setIsTooltipOpen(e.open)}
                                                contentProps={{
                                                    css: {
                                                        "--tooltip-bg": "gray",
                                                    },
                                                }}
                                            >
                                                <Icon
                                                    boxSize={6}
                                                    color="blue.500"
                                                    cursor="pointer"
                                                    mr={3}
                                                    onClick={() => setIsTooltipOpen(!isTooltipOpen)}
                                                    onMouseEnter={() => setIsTooltipOpen(true)}
                                                    onMouseLeave={() => setIsTooltipOpen(false)}
                                                >
                                                    <InfoIcon />
                                                </Icon>
                                            </Tooltip>
                                        </Box>
                                        <Field.ErrorText color="red.500">
                                            El código de propiedad sólo puede contener letras y
                                            números.
                                        </Field.ErrorText>
                                    </Field.Root>
                                </GridItem>
                            </Grid>
                        </GridItem>
                    )}
                    {desarrolloInteres === "Desarrollos en preventa" && (
                        <GridItem colSpan={1}>
                            <Field.Root mb={0}>
                                <Select.Root
                                    collection={otherFieldOptions}
                                    borderWidth={1.5}
                                    borderColor="#D9D9D9"
                                    rounded="full"
                                    boxShadow="none"
                                    _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                    marginBottom="10px"
                                    id="other_project"
                                    type="text"
                                    value={project == "" ? [] : [project]}
                                    required
                                    onValueChange={(details) => {
                                        setProject(details.value[0]);
                                    }}
                                >
                                    <Select.HiddenSelect />
                                    <Select.Control>
                                        <Select.Trigger pl={4} rounded="full">
                                            <Select.ValueText
                                                color="gray.500"
                                                placeholder="Selecciona un producto"
                                            />
                                        </Select.Trigger>
                                        <Select.IndicatorGroup pr={4}>
                                            <Select.Indicator />
                                        </Select.IndicatorGroup>
                                    </Select.Control>
                                    <Select.Positioner>
                                        <Select.Content p={2}>
                                            {otherFieldOptions.items.map((field) => (
                                                <Select.Item
                                                    item={field}
                                                    key={field.value}
                                                    color="gray.600"
                                                    p={1}
                                                >
                                                    <Select.ItemText>{field.label}</Select.ItemText>
                                                    <Select.ItemIndicator />
                                                </Select.Item>
                                            ))}
                                        </Select.Content>
                                    </Select.Positioner>
                                </Select.Root>
                            </Field.Root>
                        </GridItem>
                    )}
                    <GridItem colSpan={{ base: 1, md: 2 }}>
                        <Field.Root mb={3}>
                            <Select.Root
                                collection={contactOrigin}
                                borderWidth={1.5}
                                borderColor="#D9D9D9"
                                rounded="full"
                                boxShadow="none"
                                _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                marginBottom="10px"
                                id="medio"
                                type="text"
                                value={medio == "" ? [] : [medio]}
                                required
                                onValueChange={(details) => {
                                    setMedio(details.value[0]);
                                }}
                            >
                                <Select.HiddenSelect />
                                <Select.Control>
                                    <Select.Trigger pl={4} rounded="full">
                                        <Select.ValueText placeholder="¿Cómo te enteraste del proyecto?" />
                                    </Select.Trigger>
                                    <Select.IndicatorGroup pr={4}>
                                        <Select.Indicator />
                                    </Select.IndicatorGroup>
                                </Select.Control>
                                <Select.Positioner>
                                    <Select.Content p={2}>
                                        {contactOrigin.items.map((contact) => (
                                            <Select.Item
                                                item={contact}
                                                key={contact.value}
                                                color="gray.600"
                                                p={1}
                                            >
                                                <Select.ItemText>{contact.label}</Select.ItemText>
                                                <Select.ItemIndicator />
                                            </Select.Item>
                                        ))}
                                    </Select.Content>
                                </Select.Positioner>
                            </Select.Root>
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={{ base: 1, md: 2 }}>
                        <Text fontWeight={700} fontSize="lg" textAlign="left" mb="0">
                            ¿Ya estás siendo atendido por un asesor de Grupo Guía?
                        </Text>
                    </GridItem>
                    <GridItem colSpan={{ base: 1, md: 2 }}>
                        <Field.Root mb={0}>
                            <Select.Root
                                collection={confirmOptions}
                                w="30%"
                                marginRight="auto"
                                value={isAt == "" ? [] : [isAt]}
                                borderWidth={1.5}
                                borderColor="#D9D9D9"
                                rounded="full"
                                boxShadow="none"
                                _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                required
                                onValueChange={(details) => {
                                    setIsAt(details.value[0]);
                                }}
                            >
                                <Select.HiddenSelect />
                                <Select.Control>
                                    <Select.Trigger pl={4} rounded="full">
                                        <Select.ValueText placeholder="SÍ/NO" />
                                    </Select.Trigger>
                                    <Select.IndicatorGroup pr={4}>
                                        <Select.Indicator />
                                    </Select.IndicatorGroup>
                                </Select.Control>
                                <Select.Positioner>
                                    <Select.Content p={2}>
                                        {confirmOptions.items.map((option) => (
                                            <Select.Item
                                                item={option}
                                                key={option.value}
                                                color="gray.600"
                                                p={1}
                                            >
                                                {option.label}
                                                <Select.ItemIndicator />
                                            </Select.Item>
                                        ))}
                                    </Select.Content>
                                </Select.Positioner>
                            </Select.Root>
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={{ base: 1, md: 2 }}>
                        <Field.Root mb={3}>
                            <Input
                                borderWidth={1.5}
                                borderColor="#D9D9D9"
                                rounded="full"
                                boxShadow="none"
                                _focus={{ borderWidth: 1, borderColor: "gray.400" }}
                                placeholder="Nombre(s) y Apellido(s) del asesor"
                                marginBottom="10px"
                                id="nombre_asesor_atiende"
                                type="text"
                                py={5}
                                px={4}
                                value={nombreAsesorAt}
                                required
                                onChange={(e) => {
                                    e.preventDefault();
                                    setNombreAsesorAt(e.target.value);
                                }}
                                onBlur={(e) => {
                                    e.preventDefault();
                                    setNombreAsesorAt(e.target.value);
                                }}
                                disabled={isAt !== "No" ? false : true}
                            />
                        </Field.Root>
                    </GridItem>
                    <GridItem colSpan={{ base: 1, md: 2 }}>
                        <Field.Root mb={3} alignItems="center">
                            <Checkbox required colorPalette="blue" color="accent.500">
                                Acepto los{" "}
                                <Link
                                    color="#317FDA"
                                    href="/terminosycondiciones-guiabroker"
                                    external
                                >
                                    Términos y condiciones.
                                </Link>
                            </Checkbox>
                        </Field.Root>
                    </GridItem>
                </Grid>
                <Button
                    rounded="full"
                    w={isGreaterThanMd ? "30%" : "50%"}
                    margin="auto"
                    fontWeight="500"
                    color="white"
                    bg="#888888"
                    borderColor="#888888"
                    _hover={{
                        bg: "#646464",
                    }}
                    type="submit"
                >
                    Enviar
                </Button>
            </form>
        </>
    );
};
export default FormRegistro;
